import { BDropdownDivider } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBDropdownDivider when migrating. */
export const EgBDropdownDivider = createEgBootstrapProxy(
  "EgBDropdownDivider",
  BDropdownDivider
);
